<h3 mat-dialog-title>Plaid Details for {{data.friendlyName}}</h3>

<mat-dialog-content class="small-content">
    <p>Access Token: {{data.plaidToken}}</p>
    <p>Item ID: {{data.plaidItemId}}</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>
        Ok
    </button>
</mat-dialog-actions>
